// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_A9w","cls2":"SimplePaperPodcast-cls2_Hdu SimplePaperPodcast-cls1_A9w"};